/**
 * Shared default data structures for printer configuration.
 * Used by usePrinterConfig and usePrepheralCardFooter to avoid duplication.
 */

export function mapSalesModes(
    salesModes: any[],
    state: boolean
): { designation: string; state: boolean }[] {
    return salesModes.map((el: any) => ({
        designation: el.designation,
        state,
    }));
}

export function createDefaultKitchenTicket(
    salesModes: any[],
    isKitchenActive: boolean
): any {
    return {
        note_kitchen_ticket: {
            print_note: isKitchenActive,
        },
        ticketKitchenModeSale: mapSalesModes(salesModes, isKitchenActive),
        customerAddressModeSale: mapSalesModes(salesModes, false),
        customer_information_mode_sale: {
            customerInformationModeSaleName: mapSalesModes(salesModes, false),
            customerInformationModeSaleNumTel: mapSalesModes(salesModes, false),
            customerInformationModeSaleCity: mapSalesModes(salesModes, false),
            customerInformationModeSaleAdress: mapSalesModes(salesModes, false),
            customerInformationModeSaleCode: mapSalesModes(salesModes, false),
            customerInformationModeSaleCompany: mapSalesModes(salesModes, false),
        },
    };
}

export function createDefaultCustomerTicket(
    salesModes: any[],
    isCustomerActive: boolean
): any {
    return {
        customerTicketSalesModes: mapSalesModes(salesModes, isCustomerActive),
        dateTimeDeliveryModeSale: mapSalesModes(salesModes, false),
        print_date_time_delivery_mode_sale: {
            provider_name: false,
            without_price: isCustomerActive,
            print_notes: isCustomerActive,
            items_lines: false,
            method_payment: false,
            method_payment_TVA: false,
        },
    };
}

export function createDefaultModelKitchenTicket(): any {
    return {
        model_1: {
            black_background: true,
            isChecked: true,
            smaller_font: true,
        },
        model_2: {
            isChecked: false,
            menu_component: false,
            name_menu: false,
            online_order: false,
            single_label: false,
        },
        model_3: {
            Activate_manual_dispatch_follow: false,
            dispatch_automatically_follow: false,
            follow_kitchen_ticket: false,
            font_small: false,
            isChecked: false,
            order_kitchen: false,
            Send_changes_kitchen: false,
            ticket_additions_cancellations: false,
        },
        model_4: { isChecked: false },
        model_5: { isChecked: false },
    };
}

export function createDefaultGeneralSettings(
    includeOrderNumber: boolean = false
): any {
    const ticketHeader: any = {
        logo_customer: false,
        logo_kitchen: false,
        Path_customer: "",
        Path_kitchen: "",
        sale_mode_bold: true,
        name_phone_number_bold: false,
        sale_mode_black_backround: false,
    };
    if (includeOrderNumber) {
        ticketHeader.ticketHeaderStyleOrderNumber = false;
    }
    return {
        automatic_printing: {
            NumberCustomer: 1,
            NumberTicketsKitchen: 1,
        },
        information_mode: {
            information_bold: false,
            printer_information_mode: false,
        },
        ticket_header: ticketHeader,
    };
}

export function createDefaultDiversSettings(
    withBarcodeDefaults: boolean = false
): any {
    return {
        Code: {
            barcode_ticket: withBarcodeDefaults ? "2" : "",
            checked_barcode_ticket: withBarcodeDefaults,
            checked_QR_code: false,
            QR_code: withBarcodeDefaults ? "1" : "",
        },
        paperless_ticket: {
            paperless_ticket_custom: true,
        },
        printing_options: {
            force_paper: false,
            special_characters: false,
        },
    };
}
